/* eslint-disable
    import/no-webpack-loader-syntax,
*/
require('jquery/jquery.validate')
require('script-loader!legacy/jquery.cookie')
require('./Signup/newSignup')
require('./Login/testimonialCarousel')
